import { Building } from '../../confi-state';
import { ServiceManager } from '../../services/service-manager';
import { buildingType } from '../BuildingConf/models/building-type.enum';
import styles from './DocumentationSelection.module.css';

const DocumentationSelection = ({ buildings, onChangeBuilding }: { buildings: Building[], onChangeBuilding: (projectId: number | string, siteId: number | string, building: Building, saveToDb?: boolean) => void }) => {


    const handleSelectFloor = (building: Building, floor: number) => {
        const b = { ...building };
        if (!b.floorsForDoc) {
            b.floorsForDoc = [];
        }
        if (b.floorsForDoc.some(f => f === floor)) {
            b.floorsForDoc = b.floorsForDoc.filter(f => f !== floor);
        } else {
            b.floorsForDoc.push(floor);
            b.floorsForDoc = b.floorsForDoc.sort((a, b) => a - b);
        }
        onChangeBuilding(b.projectId, b.siteId, { ...b }, true);
    };

    return (
        <div className={styles.DocumentationSelection} data-testid="DocumentationSelection">
            {/* {
                buildings.map(building => {
                    return (
                        <div key={building.id} className={styles.building}>
                            <input className={styles.checkboxInput}
                                id={"building" + building.id} type="checkbox" checked={building.selectedForDoc}
                                value={building.id}
                                onChange={() => onChangeBuilding(building.projectId, building.siteId, { ...building, selectedForDoc: !building.selectedForDoc }, true)} />
                            <label title={building.type !== buildingType.singleLoadedCorridor ? "Type niet toegestaan" : ""} htmlFor={"building" + building.id}>
                                {building.name}
                            </label>
                            {
                                building.selectedForDoc && (
                                    <div className="building">
                                        {ServiceManager.buildingHelperService.getBuildingFloors(building).map(floor => {
                                            return (
                                                <div className={styles.floor} key={floor}>
                                                    <input className="checkbox-input" id={"building" + building.id + "floor" + floor} type="checkbox"
                                                        checked={building.floorsForDoc && building.floorsForDoc.some(f => f === floor)} value={floor}
                                                        onChange={() => handleSelectFloor(building, floor)}
                                                    />
                                                    <label title={floor} htmlFor={"building" + building.id + "floor" + floor}>
                                                        {floor === 0 ? "BG" : floor}
                                                    </label>
                                                </div>
                                            );
                                        })}
                                    </div>)
                            }
                        </div>
                    );
                })
            } */}
        </div>
    )
};

export default DocumentationSelection;
